import { render } from "./ReviewParsers.vue?vue&type=template&id=05a61800&scoped=true"
import script from "./ReviewParsers.vue?vue&type=script&lang=js"
export * from "./ReviewParsers.vue?vue&type=script&lang=js"

import "./ReviewParsers.vue?vue&type=style&index=0&id=05a61800&lang=css"
import "./ReviewParsers.vue?vue&type=style&index=1&id=05a61800&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a61800"]])

export default __exports__